import { render, staticRenderFns } from "./CustomFilterVocStatusPopup.vue?vue&type=template&id=671a11b0&scoped=true&"
import script from "./CustomFilterVocStatusPopup.vue?vue&type=script&lang=js&"
export * from "./CustomFilterVocStatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomFilterVocStatusPopup.vue?vue&type=style&index=0&id=671a11b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a11b0",
  null
  
)

export default component.exports